import { FunctionComponent, useState } from "react";
import styles from "./ApprovalMessage.module.css";
import images from '../../../assets/images/index'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

interface PropType{
  title: string,
  subTitle: string
}
const ApprovalMessage: FunctionComponent<PropType> = ({title, subTitle}) => {
  const {roundedDoneIcon,CopyIcon} = images;
  const [copied,setCopied] = useState<boolean>(false);

  const handleCopy = (_text: string,result: boolean) => {
    setCopied(result);
    setTimeout(() => {
      setCopied(false);
    },2000)
  }
  return (
    <div className={styles.topContent}>
      <div className={styles.utilitiesPopupStatus}>
        <img
          className={styles.roundedOutlineDone}
          alt="doneIcon"
          src={roundedDoneIcon}
        />
      </div>
      <div className={styles.textContainer}>
        <b className={styles.emailSentSuccessfully}>{title}</b>
        <b className={title === "Affiliate Created Successfully!" ? styles.affiliateSentSuccessful : styles.weHaveSent}>
          {
           title === "Affiliate Created Successfully!" ?
           subTitle !== "" ? 
           <>
           <span className={styles.referralLink}>{`${subTitle}`}</span>
           <CopyToClipboard text={subTitle} onCopy={handleCopy}>
           <span className={styles.copyIconSpan}>
            {copied
            ? <CheckCircleOutlinedIcon style={{color: "#5D75F8"}}/>
            : <img
                className={styles.CopyIcon}
                alt = "copyicon"
                src={CopyIcon}
              />
            }
           </span>
           </CopyToClipboard>
           </> : <></>
           : subTitle
          }
        </b>
      </div>
    </div>
  );
};

export default ApprovalMessage;
